import script from "./sub3Option.vue?vue&type=script&setup=true&lang=js"
export * from "./sub3Option.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__